var _path, _path2, _path3, _path4, _linearGradient, _path5, _linearGradient2, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTradingview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41,24c-0.032-0.81-0.007-2.775,0.02-4.307c0.013-0.743-0.885-1.122-1.41-0.597l-8.441,8.442 l0.261,0.62c0.2,0.473,0.247,0.99,0.137,1.519c-0.179,0.863-0.848,1.591-1.694,1.838c-1.697,0.496-3.248-0.769-3.248-2.391 c0-0.226,0.041-0.46,0.13-0.74l0.19-0.604l-6.801-6.291l-0.606,0.277c-0.674,0.308-1.396,0.307-2.056,0.011l-0.576-0.259 L5.005,31.616c-0.697,0.591-0.383,1.726,0.518,1.875C6.996,33.736,8.854,34,10,34l29.874,0c2.85,0,5.201-2.335,5.123-5.184 C44.928,26.229,43.368,25.12,41,24z",
    opacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31,18c-1.806-4.488-5.097-8-10-8c-5.954,0-9.062,4.219-10,10c-4.573,0.423-8,2.318-8,7 c0,0.739-0.092,2.081-0.183,3.231c-0.061,0.766,0.833,1.225,1.419,0.727l12.025-10.204l-0.162-0.61 c-0.177-0.663-0.104-1.002,0.13-1.55c0.348-0.813,1.072-1.464,1.949-1.575C19.7,16.829,21,18.015,21,19.5 c0,0.184-0.028,0.38-0.09,0.617l-0.15,0.579l6.857,6.344l0.586-0.232c0.51-0.202,0.948-0.263,1.616-0.068l0.568,0.166l8.587-8.586 c0.494-0.494,0.124-1.34-0.574-1.304C36.144,17.132,32.547,17.405,31,18z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5,25c0-0.002-1.5-1.998-1.5-2c0-0.886-0.009-2.422-0.015-3.465 c-0.003-0.408-0.496-0.609-0.785-0.321l-8.441,8.441l0.131,0.31c0.188,0.446,0.264,0.924,0.224,1.417 c-0.107,1.297-1.097,2.427-2.373,2.683c-1.923,0.385-3.616-1.082-3.616-2.938c0-0.277,0.049-0.561,0.152-0.891l0.096-0.302 l-6.324-5.85l-0.303,0.138c-0.808,0.369-1.679,0.368-2.469,0.013l-0.288-0.13L4.97,32.303c-0.38,0.322-0.224,0.94,0.264,1.04 C6.559,33.613,8.688,34,10,34l30.672,0c2.394,0,4.327-1.943,4.327-4.337C45,26.426,45.097,26.083,42.5,25z",
    opacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18c-1.602-4.562-4.129-8-9-8c-5.839,0-9.264,4.263-10,10c-4.502,0.209-8,2.446-8,7 c0,0.757-0.348,0.992,0,2c0.13,0.376,0.008,1.754,0.008,1.754s0.681,0.012,0.966-0.229l11.722-9.946l-0.081-0.306 c-0.127-0.474-0.143-0.82-0.077-1.191c0.236-1.316,1.293-2.416,2.622-2.563C19.966,16.32,21.5,17.734,21.5,19.5 c0,0.227-0.034,0.463-0.106,0.743l-0.074,0.289l6.406,5.927l0.293-0.116c0.612-0.244,1.169-0.31,1.941-0.083l0.284,0.082 l8.567-8.567c0.278-0.278,0.083-0.754-0.31-0.75C36.396,17.047,31.744,17.19,30,18z",
    opacity: 0.07
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O3weN6LIuCTrWKpFTpYxaa_dzNbXtMyJ0Iy_gr1",
    x1: 10.017,
    x2: 38.303,
    y1: 16.734,
    y2: 37.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O3weN6LIuCTrWKpFTpYxaa_dzNbXtMyJ0Iy_gr1)",
    d: "M41.982,23.342C41.988,23.228,42,23.116,42,23c0-1.39-0.41-2.681-1.108-3.77l-8.54,8.54 c0.175,0.417,0.273,0.875,0.273,1.356c0,1.933-1.567,3.5-3.5,3.5s-3.5-1.567-3.5-3.5c0-0.365,0.072-0.71,0.175-1.041l-5.846-5.409 C19.509,22.879,19.02,23,18.5,23c-0.51,0-0.991-0.115-1.428-0.311L4.817,33.088C6.214,34.278,8.021,35,10,35h30c3.314,0,6-2.686,6-6 C46,26.382,44.32,24.162,41.982,23.342z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O3weN6LIuCTrWKpFTpYxab_dzNbXtMyJ0Iy_gr2",
    x1: 10.385,
    x2: 38.671,
    y1: 16.234,
    y2: 37.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O3weN6LIuCTrWKpFTpYxab_dzNbXtMyJ0Iy_gr2)",
    d: "M15.132,20.401C15.054,20.112,15,19.814,15,19.5c0-1.933,1.567-3.5,3.5-3.5s3.5,1.567,3.5,3.5 c0,0.302-0.05,0.589-0.122,0.868l5.956,5.51c0.4-0.159,0.834-0.253,1.291-0.253c0.341,0,0.663,0.064,0.974,0.155l8.671-8.671 C37.681,16.41,36.39,16,35,16c-1.255,0-2.429,0.334-3.447,0.912C30.217,12.342,26.002,9,21,9c-5.738,0-10.445,4.396-10.95,10.003 C10.033,19.002,10.017,19,10,19c-4.418,0-8,3.582-8,8c0,1.356,0.34,2.631,0.935,3.75L15.132,20.401z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingview);
export default __webpack_public_path__ + "static/media/tradingview.f0a73cfa755d7a9cd51fd620b2aadc47.svg";
export { ForwardRef as ReactComponent };